<template>
    <div class="modal fade request-cancellation-success" id="requestCancellationSuccess" tabindex="-1" role="dialog" aria-labelledby="requestCancellationSuccessLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
            <div class="modal-body p-4">
                <p>Request for cancellation successfully sent</p>
                <ColoredButton class="mt-3 w-auto" data-dismiss="modal" @click="$router.push('/booking/home')">Return to home</ColoredButton>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        computed: {
            contactDetails() {
                return this.$store.getters['GET_FOOTER_SETTINGS']; 
            }
        },
        mounted() {
            // this.$store.dispatch('footerSettings');
        }
    }
</script>